import styled, { css } from 'styled-components';
import { grey, purple } from '@material-ui/core/colors';
import device from '../constants/mediaBreakpoints';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding: 1em;
  background: white;
`;

export const Salutation = styled.p`
  color: var(--text-color);
  font-weight: 200;
  font-size: 1.2em;
  margin: 0 0 1rem 0;
`;

export const ProductDetailsWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 1 1 auto;

  @media screen and ${device.tablet} {
    flex-flow: column nowrap;
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 0 1 40%;
  min-width: 300px;
  padding: 0 1em;

  @media screen and ${device.tablet} {
    flex: 1 1 auto;
    order: 1;
  }
`;

export const PoweredBy = styled.p`
  color: var(--text-color);
  font-size: 0.9em;
  line-height: 1.4;
  text-transform: uppercase;

  margin: 0 auto;
  padding: 1em 2em;
`;

export const FooterText = styled.p`
  color: var(--text-color);
  font-size: 0.9em;
  line-height: 1.4;
  margin: 0 0 1em;
  text-align: center;
`;

export const DialogMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  flex: 1 0 auto;

  background: var(--background-color);
  border-bottom: 1px solid var(--border-color);

  max-height: 60px;
  padding: 0.5em 0;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const DialogMenuItemsLeft = styled.div`
  display: flex;
  flex-flow: row nowrap;

  max-width: 100px;
  align-items: center;
  margin: 0 0 0 0.5rem;
`;

export const DialogMenuTitle = styled.div`
  display: flex;
  align-items: center;
  flex: 1 auto;
  flex-flow: column nowrap;

  color: ${purple[500]};
  font-size: 0.9em;
  font-weight: 400;
  text-transform: uppercase;
`;

export const DialogMenuItemsRight = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 100px;
  margin: 0 1rem 0 0;
`;

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--text-color);
  border: 1px solid var(--border-color);
  border-radius: 500rem;
  transition: all 0.3s ease;

  cursor: pointer;
  height: 30px;
  margin-right: 0.5em;
  width: 30px;

  > svg {
    pointer-events: none;
  }

  &:hover {
    box-shadow: ${purple[500]} 0 5px 15px -5px;
  }

  ${(props) => props.src
    && css`
      background-image: url('${props.src}');
      background-size: cover;
      background-position: center;
    `}

  ${(props) => props.smallSize
    && css`
      width: 30px;
      height: 30px;
    `}
  
  ${(props) => props.midSize
    && css`
      width: 45px;
      height: 45px;
    `}
  
  ${(props) => props.largeSize
    && css`
      width: 80px;
      height: 80px;
    `}

   ${(props) => props.extraLargeSize
    && css`
      width: 150px;
      height: 150px;
    `}
`;

export const DashboardPageWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0 auto;
  height: fit-content;
`;

export const PanelBase = styled.div`
  display: flex;
  flex-flow: column wrap;
  background-color: white;
  border: 1px solid var(--border-color);
  border-radius: 0.3rem;
  overflow: hidden;

  h3 {
    font-size: 1em;
    font-weight: 600;
    margin: 0;
    color: ${grey[800]};
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;

  ${(props) => props.small
    && css`
      div,
      .circle,
      .orbit {
        height: 2em;
        width: 2em;
      }
    `}
`;

export const ModalContent = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-flow: column nowrap;

  margin: auto;
  max-width: 680px;
  width: 100%;
`;

export const SettingPageInnerHeader = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: baseline;
  padding-bottom: 0.5rem;
`;

export const ActionButtonWrapper = styled.div`
  margin: 0 0 0 auto;
`;
